(window), $.fn.twentytwenty = function (y) {
    var y = $.extend({
        default_offset_pct: .5,
        orientation: "horizontal",
        before_label: "Before",
        after_label: "After",
        no_overlay: !1,
        move_slider_on_hover: !1,
        move_with_handle_only: !0,
        click_to_move: !1
    }, y);
    return this.each(function () {
        var t = y.default_offset_pct,
            a = $(this),
            h = y.orientation,
            s = h === "vertical" ? "down" : "left",
            d = h === "vertical" ? "up" : "right";
        if (a.wrap("<div class='twentytwenty-wrapper twentytwenty-" + h + "'></div>"), !y.no_overlay) {
            a.append("<div class='twentytwenty-overlay'></div>");
            var p = a.find(".twentytwenty-overlay");
            p.append("<div class='twentytwenty-before-label' data-content='" + y.before_label + "'></div>"), p.append("<div class='twentytwenty-after-label' data-content='" + y.after_label + "'></div>")
        }
        var b = a.find("img:first"),
            T = a.find("img:last");
        a.append("<div class='twentytwenty-handle'></div>");
        var q = a.find(".twentytwenty-handle");
        q.append("<span class='twentytwenty-" + s + "-arrow'></span>"), q.append("<span class='twentytwenty-" + d + "-arrow'></span>"), a.addClass("twentytwenty-container"), b.addClass("twentytwenty-before"), T.addClass("twentytwenty-after");
        var A = function (G) {
                var pe = b.width(),
                    Ze = b.height();
                return {
                    w: pe + "px",
                    h: Ze + "px",
                    cw: G * pe + "px",
                    ch: G * Ze + "px"
                }
            },
            D = function (G) {
                h === "vertical" ? (b.css("clip", "rect(0," + G.w + "," + G.ch + ",0)"), T.css("clip", "rect(" + G.ch + "," + G.w + "," + G.h + ",0)")) : (b.css("clip", "rect(0," + G.cw + "," + G.h + ",0)"), T.css("clip", "rect(0," + G.w + "," + G.h + "," + G.cw + ")"))
            },
            i = function (G) {
                var pe = A(G);
                q.css(h === "vertical" ? "top" : "left", h === "vertical" ? pe.ch : pe.cw), D(pe)
            },
            U = function (G, pe, Ze) {
                return Math.max(pe, Math.min(Ze, G))
            },
            oe = function (G, pe) {
                var Ze = h === "vertical" ? (pe - ee) / ne : (G - W) / ye;
                return U(Ze, 0, 1)
            };
        $(window).on("resize.twentytwenty", function (G) {
            i(t)
        });
        var W = 0,
            ee = 0,
            ye = 0,
            ne = 0,
            V = function (G) {
                ((G.distX > G.distY && G.distX < -G.distY || G.distX < G.distY && G.distX > -G.distY) && h !== "vertical" || (G.distX < G.distY && G.distX < -G.distY || G.distX > G.distY && G.distX > -G.distY) && h === "vertical") && G.preventDefault(), a.addClass("active"), W = a.offset().left, ee = a.offset().top, ye = b.width(), ne = b.height()
            },
            Le = function (G) {
                a.hasClass("active") && (t = oe(G.pageX, G.pageY), i(t))
            },
            ae = function (G) {
                a.hasClass("active") && (t = oe(G.pageX, G.pageY), i(t))
            },
            _e = y.move_with_handle_only ? q : a;
            console.log(_e, y.move_with_handle_only);
            _e.on("drag", function(e){
                console.log(e)
            });
        _e.on("movestart", V),  _e.on("drag", Le), _e.on("move", Le), _e.on("moveend", ae), y.move_slider_on_hover && (a.on("mouseenter", V), a.on("mousemove", Le), a.on("mouseleave", ae)), q.on("touchmove", function (G) {
            G.preventDefault()
        }), a.find("img").on("mousedown", function (G) {
            G.preventDefault()
        }), y.click_to_move && a.on("click", function (G) {
            W = a.offset().left, ee = a.offset().top, ye = b.width(), ne = b.height(), t = oe(G.pageX, G.pageY), i(t)
        }), $(window).trigger("resize.twentytwenty")
    })
}
$(".home-before-after .img").twentytwenty({
    default_offset_pct: 0.5,
    orientation: 'horizontal',
    no_overlay: true
});
if(window.innerWidth>769){
let slider;
var arrows = $(`[data-section-type="featured-collection-new"] [data-products-container-new]`).attr('arrows');
var slides_to_view = $(`[data-section-type="featured-collection-new"] [data-products-container-new]`).attr('slides_to_view');
loadAssets(['swiper.css', 'swiper.js']).then(() => {
    slider = new MinimogLibs.Swiper(`[data-section-type="featured-collection-new"] [data-products-container-new]`, {
        slidesPerView: slides_to_view,
        loop: true,
        autoplay: false,
        arrows: arrows,
        spaceBetween: 28
    })

    if (slider) {
        const prevBtn = document.querySelector(`[data-section-type="featured-collection-new"] .new-slider-button.previous`);
        const nextBtn = document.querySelector(`[data-section-type="featured-collection-new"] .new-slider-button.next`);
        prevBtn && prevBtn.addEventListener('click', () => slider.slidePrev());
        nextBtn && nextBtn.addEventListener('click', () => slider.slideNext());
    }
});
}$('.video-container-mrk .sf-video__inner').click(function(){
    $(this).fadeOut();
    $('.mrk-video').trigger('play');
    $('.mrk-video').attr('controls', '');
});
$('.mrk-video').on('ended',function(){
      $(this).removeAttr('controls');
      $('.video-container-mrk .sf-video__inner').fadeIn();
});